/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateFuturesBrokersByIdRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class FuturesBrokersMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateFuturesBrokers
   * @request POST:/futuresBrokers-mass-updates
   * @secure
   */
  updateFuturesBrokers = (data: UpdateFuturesBrokersByIdRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresBrokers-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsFuturesBrokersMassUpdates
   * @request OPTIONS:/futuresBrokers-mass-updates
   */
  optionsFuturesBrokersMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresBrokers-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
